import { render, staticRenderFns } from "./ColumnsSettingsModal.vue?vue&type=template&id=35b09628&scoped=true&"
import script from "./ColumnsSettingsModal.vue?vue&type=script&lang=js&"
export * from "./ColumnsSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./ColumnsSettingsModal.vue?vue&type=style&index=0&id=35b09628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b09628",
  null
  
)

export default component.exports